export default "__VITE_ASSET__IfEK1WzQ__"